import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Link } from '../../../../../atoms/Link/Link';
import { useTranslation } from '../../../../../i18n/resources';
import { FacebookIcon } from '../../../../../icons/Facebook';
import { InstagramIcon } from '../../../../../icons/Instagram';
import { LinkedInIcon } from '../../../../../icons/LinkedIn';
import { TwitterIcon } from '../../../../../icons/Twitter';
import { emails, phoneNumbers } from '../../../../../services/contacts';
import styles from './FooterContactInfo.module.css';

export type FooterContactInfo = {
  className?: string;
};

export const FooterContactInfo: FunctionComponent<FooterContactInfo> = ({
  className,
}) => {
  const { renderTrans, t } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.heading}>
        {t('footer', 'contact_member_services')}
      </div>
      <Link
        className={styles.phoneNumber}
        href={phoneNumbers.memberServices.href}
      >
        {phoneNumbers.memberServices.number}
      </Link>
      <div className={styles.businessHours}>
        {renderTrans('common', 'hours')}
      </div>
      <Link className={styles.email} href={emails.memberServices.href}>
        {emails.memberServices.address}
      </Link>
      <div className={styles.socials}>
        <Link href="https://www.facebook.com/MyChristianCare">
          <FacebookIcon />
        </Link>
        <Link href="https://www.instagram.com/medishare/">
          <InstagramIcon />
        </Link>
        <Link href="https://twitter.com/MyChristianCare">
          <TwitterIcon />
        </Link>
        <Link href="https://www.linkedin.com/company/christian-care-ministry/mycompany/">
          <LinkedInIcon />
        </Link>
      </div>
    </div>
  );
};
